import { Layout, Menu, Breadcrumb } from 'antd';
import React from 'react';
import { connect } from "react-redux";
import logo from '../logo.png';
import * as actions from '../redux/actions/employee';
import * as roleActions from '../redux/actions/roles';
import * as productActions from '../redux/actions/products';
import * as agentActions from '../redux/actions/agents';
import * as authActions from '../redux/actions/auth';
import {
    LogoutOutlined,
    UserOutlined,
    HddOutlined,
    TeamOutlined,
    TransactionOutlined,
    ScheduleOutlined,
    SwapOutlined
} from '@ant-design/icons';
import { Link, withRouter } from 'react-router-dom';
import ResetPassword from './ResetPassword';
import EditEmployee from './EditEmployee';
import EditProduct from './EditProduct';
import EditAgent from './EditAgent';
import AddAgentProduct from './AddAgentProduct';
import EditAgentProduct from './EditAgentProduct';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

class Dashboard extends React.Component {
    componentDidMount() {
        const token = this.props.token;
        this.props.onGetEmployees(token);
        this.props.onGetRoles(token);
        this.props.onGetProducts(token);
        this.props.onGetAgents(token);
        this.props.onCurrentUser(token)
    }
    state = {
        collapsed: false,
    };

    onCollapse = collapsed => {
        console.log(collapsed);
        this.setState({ collapsed });
    };

    render() {
        let isAdmin = false;
        if (this.props.currentUser) {
            isAdmin = this.props.currentUser.roles[0].name === 'ROLE_ADMIN';
        }
        let isDisplay = isAdmin ? null : { display: 'none' };
        const { collapsed } = this.state;
        return (
            <Layout style={{ minHeight: '100vh' }}>
                <EditEmployee />
                <ResetPassword />
                <EditProduct />
                <EditAgent />
                <AddAgentProduct />
                <EditAgentProduct />
                <Sider collapsible collapsed={collapsed} onCollapse={this.onCollapse}>
                    <img className="dashboard-logo" src={logo} alt="logo" />
                    <Menu theme="dark" defaultSelectedKeys={['7']} defaultOpenKeys={['sub4']} mode="inline">
                        <SubMenu key="sub1" icon={<UserOutlined />} title="Users" style={isDisplay}>
                            <Menu.Item key="1"><span>Create</span><Link to="/createUser" /></Menu.Item>
                            <Menu.Item key="2"><span>List</span><Link to="/dashboard" /></Menu.Item>
                        </SubMenu>
                        <SubMenu key="sub2" icon={<HddOutlined />} title="Products" style={isDisplay}>
                            <Menu.Item key="3"><span>Create</span><Link to="/createProduct" /></Menu.Item>
                            <Menu.Item key="4"><span>List</span><Link to="/products" /></Menu.Item>
                        </SubMenu>
                        <SubMenu key="sub3" icon={<TeamOutlined />} title="Agents" style={isDisplay}>
                            <Menu.Item key="5"><span>Create</span><Link to="/createAgent" /></Menu.Item>
                            <Menu.Item key="6"><span>List</span><Link to="/agents" /></Menu.Item>
                        </SubMenu>
                        <SubMenu key="sub4" icon={<TransactionOutlined />} title="Transactions">
                            <Menu.Item key="7"><span>Win/Lose</span><Link to="/winlose" /></Menu.Item>
                        </SubMenu>
                        <SubMenu key="sub5" icon={<ScheduleOutlined />} title="Reports">
                            <Menu.Item key="8"><span>Win/Lose</span><Link to="/reportsms" /></Menu.Item>
                            <Menu.Item key="9"><span>Statement</span><Link to="/statement" /></Menu.Item>
                            <Menu.Item key="10"><span>Correction</span><Link to="/correction" /></Menu.Item>
                        </SubMenu>
                        <SubMenu key="sub6" icon={<SwapOutlined />} title="Manage Cash">
                            <Menu.Item key="11"><span>Transfer</span><Link to="/transfer-collector" /></Menu.Item>
                            <Menu.Item key="12"><span>History</span><Link to="/collector-history" /></Menu.Item>
                        </SubMenu>
                        <Menu.Item key="13" icon={<LogoutOutlined />}>
                            <span>Logout</span>
                            <Link to="/logout" />
                        </Menu.Item>
                    </Menu>
                </Sider>
                <Layout className="site-layout">
                    <Header className="site-layout-background" style={{ padding: 0 }} />
                    <Content style={{ margin: '0 16px' }}>
                        <Breadcrumb style={{ margin: '16px 0' }}>
                            <Breadcrumb.Item>User</Breadcrumb.Item>
                            <Breadcrumb.Item>{isAdmin?`Admin`:`Manager`}</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                            {this.props.children}
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
                </Layout>
            </Layout>
        );
    }
}
const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath,
        token: state.auth.token,
        currentUser: state.auth.currentUser,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onGetEmployees: (token) => dispatch(actions.getEmployees(token)),
        onGetRoles: (token) => dispatch(roleActions.getRoles(token)),
        onGetProducts: (token) => dispatch(productActions.getProduct(token)),
        onGetAgents: (token) => dispatch(agentActions.getAgents(token)),
        onCurrentUser: (token) => dispatch(authActions.currentUserDetail(token)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));